module.exports = __webpack_public_path__ + "img/cjjes.4d9ea0cb.png";